(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('sellerSection', sellerSection);

    /* @ngInject */
    function sellerSection($sce, $http, $rootScope) {
        var directive = {
            bindToController: true,
            templateUrl: 'seller-section.tpl',
            controller: sellerSectionController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                sellerId: '<',
                data: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.vm.youtube = '';
            if(scope.vm.data.seller_data.hq.video.value) {
                scope.vm.getUrl = function(id) {
                    return '//www.youtube.com/embed/' + id + '?rel=0';
                };
                scope.vm.youtube = $sce.trustAsHtml('<iframe width="560" height="315" src="' + scope.vm.getUrl(scope.vm.data.seller_data.hq.video.value) + '" frameborder="0" allowfullscreen></iframe>');
            }

            if(!scope.vm.data.seller_data.hq['page-image'].value) {
                scope.vm.data.seller_data.hq['page-image'].value = scope.$root.globals.site_options.seller_team_defaults.seller_default_image;
            }

            if (scope.vm.data.seller_data.hq['video-image'].value == 'image') {
                scope.vm.youtube = '';
            }

            if(!scope.vm.data.seller_data.hq['page-text'].value) {
                scope.vm.data.seller_data.hq['page-text'].value = scope.$root.globals.site_options.seller_team_defaults.seller_default_text;
            }

            // scope.vm.$jed = angular.element(element).find('.seller-description .editor').first();
            scope.vm.temp = '';

            scope.vm.doEdit = function(e) {
                console.log('doEdit');
                scope.vm.inEdit = true;
                // scope.vm.$jed.attr({ contenteditable: true });
                scope.vm.temp = scope.vm.data.seller_data.hq['page-text'].value;
            };

            scope.vm.doExit = function(e) {
                console.log('doExit');
                // scope.vm.$jed.attr({ contenteditable: false });
                scope.vm.data.seller_data.hq['page-text'].value = scope.vm.temp;
                scope.vm.inEdit = false;
            };

        }

    }

    /* @ngInject */
    function sellerSectionController ($scope, $rootScope, $http) {
        // $scope.vm.baseurl = baseurl;
        $scope.vm.baseurl = 'http://pie.dev.limusdesign.com';

        $scope.vm.inEdit = false;
        $rootScope.uploadMediaValue = '';
        $rootScope.uploadImg = false;
        $scope.vm.openUpload = function(uploadImg, uploadMediaValue) {
            $rootScope.uploadImg = uploadImg;
            $rootScope.uploadMediaValue = uploadMediaValue;
            $rootScope.openModal("upload-media");
        };

        $scope.vm.doSave = function(method, data) {
            if (!$scope.saving) {
                $scope.saving = true;
                $scope.vm.inEdit = false;
                $http.post(ajaxurl, {
                    action: 'pie_action',
                    method: 'save_seller_data',
                    nonce: $scope.$root.stats.nonce,
                    params: {
                        hq: {
                            'page-text': {
                                value: $scope.vm.data.seller_data.hq['page-text'].value
                            }
                        }
                    }
                }).then(function(response) {
                    console.log(response.data);
                    $scope.saving = false;
                });
            }
        };


    }

})();